import React from 'react';
import './Loading.css';

const Loading = () => {
  return (
    <div className="loading-container">
      <div className="loading-content">
        <div className="loading-logo">
          <span>S</span>
          <span>o</span>
          <span>u</span>
          <span>l</span>
          <span>m</span>
          <span>e</span>
          <span>g</span>
          <span>l</span>
          <span>e</span>
        </div>
        
        <div className="loading-animation">
          <div className="loading-spinner"></div>
          <div className="loading-circles">
            <div className="circle circle-1"></div>
            <div className="circle circle-2"></div>
            <div className="circle circle-3"></div>
          </div>
        </div>
        
        <p className="loading-text">Connecting souls...</p>
        <p className="loading-subtext">Finding your perfect match</p>
      </div>
      
    </div>
  );
};

export default Loading;
